// JobList.jsx
import React, { useState } from "react";
import {
  Container,
  Card,
  Button,
  Dropdown,
  Form,
  Table,
  Modal,
  Row,
  Col,
  Tab,
  Nav,
  Breadcrumb,
} from "react-bootstrap";
import { FiList, FiGrid } from "react-icons/fi";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { FiChevronDown } from "react-icons/fi";

import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import JobGridView from "../../components/Dashboard/admin-dashboard/JobGridView";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { FiCalendar } from "react-icons/fi";
import PostJobModal from "../../components/modals/admin-dashboard/PostJobModal";
import PostJobeditModal from "../../components/modals/admin-dashboard/PostJobeditModal";
import DeleteConfirmModal from "../../components/modals/admin-dashboard/DeleteConfirmModal";

const JobsPage = () => {
  const [viewMode, setViewMode] = useState("list");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showPostModal, setShowPostModal] = useState(false);
  const [activeTab, setActiveTab] = useState("basic");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [currentJob, setCurrentJob] = useState(null);
  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

  const statusOptions = ["Accepted", "sent", "Expired", "Declined"];
  const [selected, setSelected] = useState("Last 7 Days");
  // Form State
  const [jobForm, setJobForm] = useState({
    title: "",
    description: "",
    category: "",
    jobType: "",
    level: "",
    experience: "",
    qualification: "",
    gender: "",
    minSalary: "",
    maxSalary: "",
    expiredDate: "",
    skills: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  // Image Upload State
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  // Dummy Data
  const [jobs, setJobs] = useState([
    {
      id: "Job-001",
      title: "Senior iOS Developer",
      applicants: 25,
      location: "New York, USA",
      salary: "30,000 - 35,000 / month",
      experience: "2 years of experience",
      icon: "assets/img/icons/apple.svg",
      filled: 10,
      total: 25,
      category: "iOS Development",
      jobType: "Full-time",
      level: "Senior",
      qualification: "Bachelor's Degree",
      gender: "Male",
      minSalary: "30000",
      maxSalary: "35000",
      expiredDate: "2024-12-31",
      skills: "Swift, Objective-C",
      address: "123 Main St",
      country: "USA",
      state: "New York",
      city: "New York City",
      zipCode: "10001",
    },

    {
      id: "Job-002",
      title: "Junior PHP Developer",
      applicants: 25,
      location: "Los Angeles, USA",
      salary: "20,000 - 25,000 / month",
      experience: "4 years of experience",
      icon: "assets/img/icons/php.svg",
      filled: 10,
      total: 25,
      category: "Web Development",
      jobType: "Full-time",
      level: "Junior",
      qualification: "Bachelor's Degree",
      gender: "Female",
      minSalary: "20000",
      maxSalary: "25000",
      expiredDate: "2024-12-31",
      skills: "PHP, MySQL",
      address: "456 Oak St",
      country: "USA",
      state: "California",
      city: "Los Angeles",
      zipCode: "90210",
    },

    {
      id: "Job-003",
      title: "Network Engineer",
      applicants: 25,
      location: "Bristol, UK",
      salary: "30,000 - 35,000 / month",
      experience: "1 year of experience",
      icon: "assets/img/icons/black.svg",
      filled: 10,
      total: 25,
      category: "Networking",
      jobType: "Full-time",
      level: "Mid",
      qualification: "Master's Degree",
      gender: "Male",
      minSalary: "30000",
      maxSalary: "35000",
      expiredDate: "2024-12-31",
      skills: "Cisco, Networking",
      address: "789 Pine St",
      country: "UK",
      state: "England",
      city: "Bristol",
      zipCode: "BS1 1AA",
    },

    {
      id: "Job-004",
      title: "React Developer",
      applicants: 25,
      location: "Birmingham, UK",
      salary: "28,000 - 32,000 / month",
      experience: "3 years of experience",
      icon: "assets/img/icons/react.svg",
      filled: 10,
      total: 25,
      category: "Web Development",
      jobType: "Full-time",
      level: "Mid",
      qualification: "Bachelor's Degree",
      gender: "Male",
      minSalary: "28000",
      maxSalary: "32000",
      expiredDate: "2024-12-31",
      skills: "React, JavaScript",
      address: "101 Elm St",
      country: "UK",
      state: "England",
      city: "Birmingham",
      zipCode: "B1 1AA",
    },

    {
      id: "Job-005",
      title: "Laravel Developer",
      applicants: 25,
      location: "Washington, USA",
      salary: "32,000 - 36,000 / month",
      experience: "1 years of experience",
      icon: "assets/img/icons/laravel.svg",
      filled: 10,
      total: 25,
      category: "Web Development",
      jobType: "Full-time",
      level: "Senior",
      qualification: "Bachelor's Degree",
      gender: "Male",
      minSalary: "32000",
      maxSalary: "36000",
      expiredDate: "2024-12-31",
      skills: "Laravel, PHP",
      address: "202 Maple St",
      country: "USA",
      state: "Washington",
      city: "Seattle",
      zipCode: "98101",
    },

    {
      id: "Job-006",
      title: "DevOps Engineer",
      applicants: 25,
      location: "Coventry, UK",
      salary: "25,000 - 35,000 / month",
      experience: "6 years of experience",
      icon: "assets/img/icons/devops.svg",
      filled: 10,
      total: 25,
      category: "DevOps",
      jobType: "Full-time",
      level: "Senior",
      qualification: "Master's Degree",
      gender: "Male",
      minSalary: "25000",
      maxSalary: "35000",
      expiredDate: "2024-12-31",
      skills: "Docker, Kubernetes",
      address: "303 Cedar St",
      country: "UK",
      state: "England",
      city: "Coventry",
      zipCode: "CV1 1AA",
    },

    {
      id: "Job-007",
      title: "Android Developer",
      applicants: 25,
      location: "Chicago, USA",
      salary: "28,000 - 32,000 / month",
      experience: "5 years of experience",
      icon: "assets/img/icons/android.svg",
      filled: 10,
      total: 25,
      category: "Android Development",
      jobType: "Full-time",
      level: "Mid",
      qualification: "Bachelor's Degree",
      gender: "Female",
      minSalary: "28000",
      maxSalary: "32000",
      expiredDate: "2024-12-31",
      skills: "Android, Java",
      address: "404 Birch St",
      country: "USA",
      state: "Illinois",
      city: "Chicago",
      zipCode: "60601",
    },

    {
      id: "Job-008",
      title: "HTML Developer",
      applicants: 25,
      location: "Carlisle, UK",
      salary: "25,000 - 28,000 / month",
      experience: "3 years of experience",
      icon: "assets/img/icons/html.svg",
      filled: 10,
      total: 25,
      category: "Web Development",
      jobType: "Part-time",
      level: "Junior",
      qualification: "Diploma",
      gender: "Male",
      minSalary: "25000",
      maxSalary: "28000",
      expiredDate: "2024-12-31",
      skills: "HTML, CSS",
      address: "505 Spruce St",
      country: "UK",
      state: "England",
      city: "Carlisle",
      zipCode: "CA1 1AA",
    },

    {
      id: "Job-009",
      title: "UI/UX Designer",
      applicants: 25,
      location: "UI/UX Designer",
      salary: "20,000 - 25,000 / month",
      experience: "4 years of experience",
      icon: "assets/img/icons/ui.svg",
      filled: 10,
      total: 25,
      category: "Design",
      jobType: "Full-time",
      level: "Mid",
      qualification: "Bachelor's Degree",
      gender: "Female",
      minSalary: "20000",
      maxSalary: "25000",
      expiredDate: "2024-12-31",
      skills: "Figma, Adobe XD",
      address: "606 Ash St",
      country: "USA",
      state: "California",
      city: "San Francisco",
      zipCode: "94101",
    },

    {
      id: "Job-010",
      title: "Senior iOS Developer",
      applicants: 25,
      location: "San Diego, USA",
      salary: "22,000 - 28,000 / month",
      experience: "2 years of experience",
      icon: "assets/img/icons/grafic.svg",
      filled: 10,
      total: 25,
      category: "iOS Development",
      jobType: "Full-time",
      level: "Senior",
      qualification: "Master's Degree",
      gender: "Male",
      minSalary: "22000",
      maxSalary: "28000",
      expiredDate: "2024-12-31",
      skills: "Swift, Xcode",
      address: "707 Willow St",
      country: "USA",
      state: "California",
      city: "San Diego",
      zipCode: "92101",
    },
  ]);

  const filteredJobs = jobs.filter(
    (job) =>
      job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.id.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const toggleRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const toggleSelectAll = () => {
    if (selectedRows.length === filteredJobs.length) setSelectedRows([]);
    else setSelectedRows(filteredJobs.map((job) => job.id));
  };

  const handleEdit = (job) => {
    setCurrentJob(job);
    setShowModal(true);
  };

  const handleDelete = (job) => {
    setCurrentJob(job);
    setShowDelete(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setJobForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/"))
      return alert("Please select a valid image file!");
    if (file.size > 4 * 1024 * 1024)
      return alert("Image size should be below 4 MB");

    setSelectedImage(file);
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };

  const handlePostJob = (newJob) => {
    const jobId = `Job-${String(jobs.length + 1).padStart(3, "0")}`;
    const jobWithId = { ...newJob, id: jobId };
    setJobs((prev) => [...prev, jobWithId]);
    setShow(false);
    setActiveTab("basic");
    setJobForm({
      title: "",
      description: "",
      category: "",
      jobType: "",
      level: "",
      experience: "",
      qualification: "",
      gender: "",
      minSalary: "",
      maxSalary: "",
      expiredDate: "",
      skills: "",
      address: "",
      country: "",
      state: "",
      city: "",
      zipCode: "",
    });
    setSelectedImage(null);
    setImagePreview(null);
  };

  const handleEditJob = (updatedJob) => {
    setJobs((prev) =>
      prev.map((job) => (job.id === updatedJob.id ? updatedJob : job)),
    );
    setShowModal(false);
  };

  const handleDeleteJob = (jobId) => {
    setJobs((prev) => prev.filter((job) => job.id !== jobId));
    setShowDelete(false);
  };

  return (
    <Container
      fluid
      className="p-4"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {/* Top Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Jobs</h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <Link to="/">
                  <RiHome6Line
                    className="m text-dark"
                    style={{
                      fontSize: "1.2rem", // increased icon size
                      verticalAlign: "middle",
                    }}
                  />
                </Link>
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Dashboard
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Jobs</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <div className="top-actions d-flex align-items-center gap-3">
          {/* View Toggle */}
          <div className="view-toggle d-flex">
            <Button
              className={`toggle-btn ${viewMode === "list" ? "active" : ""}`}
              onClick={() => setViewMode("list")}
            >
              <FiList size={18} />
            </Button>

            <Button
              className={`toggle-btn ${viewMode === "grid" ? "active" : ""}`}
              onClick={() => setViewMode("grid")}
            >
              <FiGrid size={18} />
            </Button>
          </div>

          {/* Export */}
          <Dropdown>
            <Dropdown.Toggle className="export-btn">
              <FiDownload size={16} style={{ marginRight: "6px" }} /> Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>
                {" "}
                <FaFilePdf
                  className="mb-1"
                  size={15}
                  style={{ color: "#232323" }}
                />
                Export as PDF
              </Dropdown.Item>
              <Dropdown.Item>
                {" "}
                <FaFileExcel
                  size={15}
                  className="mb-1"
                  style={{ color: "#252525" }}
                />
                Export as Excel
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* Post Job */}
          <Button className="post-btn" onClick={() => setShow(true)}>
            <i className="bi bi-plus-lg me-2"></i> Post job
          </Button>
        </div>
      </div>

      {/* Main Card */}
      <Card className="shadow-sm border-0">
        <Card.Header className="bg-white py-3 border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              {viewMode === "grid" ? "Job Grid" : "Job List"}
            </h5>
            <div className="d-flex gap-2">
              <Dropdown className="date-dropdown">
                <Dropdown.Toggle className="date-toggle d-flex align-items-center">
                  <FiCalendar className="me-2" size={16} />
                  03/26/2026 - 04/01/2026
                </Dropdown.Toggle>

                <Dropdown.Menu className="date-menu">
                  {options.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      className={`date-item ${
                        item === "Last 7 Days" ? "active" : ""
                      }`}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown className="role-dropdown">
                <Dropdown.Toggle className="role-toggle">
                  Role <FiChevronDown className="down-icon" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="role-menu">
                  <Dropdown.Item>Senior IOS Developer</Dropdown.Item>
                  <Dropdown.Item>Junior PHP Developer</Dropdown.Item>
                  <Dropdown.Item>Network Engineer</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown className="status-dropdown">
                <Dropdown.Toggle className="status-toggle d-flex align-items-center justify-content-between">
                  Select Status
                  <FiChevronDown size={16} />
                </Dropdown.Toggle>

                <Dropdown.Menu className="status-menu">
                  {statusOptions.map((item, index) => (
                    <Dropdown.Item key={index} className="status-item">
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="sort-dropdown">
                <Dropdown.Toggle className="sort-toggle">
                  Sort By : {selected}
                  <FiChevronDown className="down-icon" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="sort-menu">
                  {options.map((item, i) => (
                    <Dropdown.Item
                      key={i}
                      onClick={() => setSelected(item)}
                      className={selected === item ? "active-item" : ""}
                    >
                      {item}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Card.Header>

        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom bg-light">
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted">Row Per Page</span>
            <Form.Select style={{ width: "80px" }}>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </Form.Select>
            <span className="text-muted">Entries</span>
          </div>
          <div style={{ width: "280px" }}>
            <Form.Control
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* GRID VIEW - Using Separate Component */}
        {viewMode === "grid" && <JobGridView jobs={filteredJobs} />}

        {/* LIST VIEW */}
        {viewMode === "list" && (
          <div className="table-responsive">
            <Table hover className="mb-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th style={{ width: "50px" }}>
                    <Form.Check
                      type="checkbox"
                      checked={
                        selectedRows.length === filteredJobs.length &&
                        filteredJobs.length > 0
                      }
                      onChange={toggleSelectAll}
                    />
                  </th>
                  <th>Job ID</th>
                  <th>Job Title</th>
                  <th>Category</th>
                  <th>Location</th>
                  <th>Salary Range</th>
                  <th>Posted Date</th>
                  <th className="text-end" style={{ width: "110px" }}>
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredJobs.map((job) => (
                  <tr key={job.id}>
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={selectedRows.includes(job.id)}
                        onChange={() => toggleRow(job.id)}
                      />
                    </td>

                    <td className="fw-medium">{job.id}</td>

                    <td>
                      <div className="d-flex align-items-center">
                        {/* ✅ ICON UPDATED ONLY */}
                        <span
                          className="me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "38px",
                            height: "38px",
                            borderRadius: "8px",
                            background: "#f3f4f6",
                          }}
                        >
                          <img
                            src={job.icon}
                            alt="icon"
                            style={{
                              width: "20px",
                              height: "20px",
                              objectFit: "contain",
                            }}
                          />
                        </span>

                        {/* TEXT (UNCHANGED) */}
                        <div>
                          <div className="fw-semibold">{job.title}</div>
                          <small className="text-muted">
                            {job.applicants} Applicants
                          </small>
                        </div>
                      </div>
                    </td>

                    <td>{job.category || "Software"}</td>
                    <td>{job.location}</td>
                    <td>{job.salary}</td>
                    <td>12 Sep 2024</td>

                    <td className="text-end">
                      <div className="action-icons">
                        <FiEdit onClick={() => handleEdit(job)} />
                        <FiTrash2 onClick={() => handleDelete(job)} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}

        <div className="d-flex justify-content-between align-items-center px-4 py-3 border-top bg-white">
          <div className="text-muted small">Showing 1 - 10 of 10 entries</div>
          <div>
            <Button variant="light" size="sm" className="me-1">
              &lt;
            </Button>
            <Button
              style={{ backgroundColor: "#ff6b1a" }}
              size="sm"
              className="me-1 border border-1"
            >
              1
            </Button>
            <Button variant="light" size="sm">
              &gt;
            </Button>
          </div>
        </div>
      </Card>

      {/* Post Job Modal */}
      <PostJobModal
        show={show}
        handleClose={() => setShow(false)}
        onSave={handlePostJob}
      />

      <PostJobeditModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        job={currentJob}
        onSave={handleEditJob}
      />
      <DeleteConfirmModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        handleDelete={() => handleDeleteJob(currentJob?.id)}
      />
      {/*  */}
      <style>
        {`
               /* Container spacing */
.top-actions {
  gap: 12px;
}

/* Toggle Wrapper */
.view-toggle {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* Toggle Buttons */
.toggle-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-size: 18px;
}

/* Active Orange Button */
.toggle-btn.active {
  background: #f97316;
  color: #fff;
}

/* Hover */
.toggle-btn:hover {
  background: #f97316;
  color: #fff;
}

/* Export Button */
.export-btn {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 8px 14px !important;
  color: #111827 !important;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.export-btn:hover {
  background: #f9fafb !important;
}

/* Post Job Button */
.post-btn {
  background: #f97316 !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  color: #fff !important;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.post-btn:hover {
  background: #ea580c !important;
}
  
  
/* Toggle (input-like box) */
.date-toggle {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 8px 14px !important;
  font-size: 14px;
  color: #111827 !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* Remove default arrow */
.date-toggle::after {
  display: none !important;
}

/* Dropdown menu */
.date-menu {
  border-radius: 10px !important;
  padding: 6px 0 !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  margin-top: 6px !important;
}

/* Triangle arrow (top) */
.date-menu::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;
  width: 10px;
  height: 10px;
  background: #fff;
  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;
  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 16px;
  font-size: 14px;
  color: #374151;
  transition: all 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (orange highlight) */
.date-item.active {
  background: #f97316 !important;
  color: #fff !important;
}
/* DROPDOWN BUTTON */

.role-toggle{
  background: #fff !important;
 border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
padding:6px 6px;
color:#111 !important;
font-size:14px;
padding:8px 16px;
display:flex;
align-items:center;
// gap:6px;
box-shadow:none !important;
}

.role-toggle::after{
display:none !important; /* remove default arrow */
}

.down-icon{
font-size:16px;
}

/* DROPDOWN MENU */

.role-menu{
border-radius:10px !important;
padding:10px 0;
border:none !important;
box-shadow:0 6px 20px rgba(0,0,0,0.08);
min-width:220px;
}

/* ITEMS */

.role-menu .dropdown-item{
font-size:14px;
padding:10px 16px;
color:#111;
}

.role-menu .dropdown-item:hover{
background:#f3f4f6;
}
/* BUTTON */

.sort-toggle{
  background: #fff !important;
 border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
color:#111 !important;
font-size:14px;
padding:8px 8px;
display:flex;
align-items:center;
justify-content:space-between;
// gap:10px;
min-width:160px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);

}

.sort-toggle::after{
display:none !important;
}

.down-icon{
font-size:16px;
}

/* MENU */

.sort-menu{
border-radius:12px !important;
padding:12px 0;
border:none !important;
box-shadow:0 8px 24px rgba(0,0,0,0.08);
min-width:240px;
}

/* ITEMS */

.sort-menu .dropdown-item{
font-size:15px;
padding:12px 18px;
color:#1f2937;
}

.sort-menu .dropdown-item:hover{
background:#f3f4f6;
}

/* ACTIVE ITEM */

.active-item{
background:#f3f4f6 !important;
font-weight:500;
}

/* Toggle Button */
.status-toggle {
  width:130px; /* adjust if needed */
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
    padding: 8px 6px !important;
  font-size: 16px;
  color: #111827 !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

/* Remove default arrow */
.status-toggle::after {
  display: none !important;
}

/* Dropdown Menu */
.status-menu {
  width: 100%;
  border-radius: 12px !important;
  padding: 8px 0 !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  margin-top: 6px !important;
}

/* Items */
.status-item {
  padding: 12px 16px;
  font-size: 16px;
  color: #374151;
}

/* Hover Effect */
.status-item:hover {
  background: #f3f4f6;
}
  /* ================= MOBILE RESPONSIVE FIX ================= */

@media (max-width: 992px) {

  /* HEADER STACK */
  .d-flex.justify-content-between.align-items-center.mb-4 {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px;
  }

  .top-actions {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .view-toggle {
    order: 1;
  }

  .export-btn,
  .post-btn {
    width: auto;
  }

  /* CARD HEADER FILTERS */
  .card-header .d-flex {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px;
  }

  .card-header .d-flex > div {
    width: 100%;
    flex-wrap: wrap;
  }

  /* DROPDOWNS FULL WIDTH */
  .date-dropdown,
  .role-dropdown,
  .status-dropdown,
  .sort-dropdown {
    width: 100%;
  }

  .date-toggle,
  .role-toggle,
  .status-toggle,
  .sort-toggle {
    width: 100% !important;
    justify-content: space-between;
  }

  /* SEARCH + ROW FILTER */
  .px-4.py-3.border-bottom.bg-light {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px;
  }

  .px-4.py-3.border-bottom.bg-light > div {
    width: 100%;
  }

  .px-4.py-3.border-bottom.bg-light input {
    width: 100% !important;
  }

  /* TABLE SCROLL */
  .table-responsive {
    overflow-x: auto;
  }

  table {
    min-width: 800px;
  }
}

/* EXTRA SMALL DEVICES */
@media (max-width: 576px) {

  .toggle-btn {
    width: 32px;
    height: 32px;
  }

  .export-btn,
  .post-btn {
    font-size: 13px !important;
    padding: 6px 10px !important;
  }

  .date-toggle,
  .role-toggle,
  .status-toggle,
  .sort-toggle {
    font-size: 13px !important;
    padding: 8px 10px !important;
  }
}
  .action-icons {
  display: flex;
  justify-content: flex-end;
  gap: 18px;
}

.action-icons svg {
  font-size: 16px;
  color: #6b7280; /* grey */
  cursor: pointer;
  transition: 0.2s;
}

.action-icons svg:first-child:hover {
  color: #2563eb; /* blue */
}

.action-icons svg:last-child:hover {
  color: #dc2626; /* red */
}
`}
      </style>
    </Container>
  );
};

export default JobsPage;
